import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'app-service-aggrement-embedded',
  templateUrl: './service-aggrement-embedded.component.html',
  styleUrls: ['./service-aggrement-embedded.component.css']
})
export class ServiceAggrementEmbeddedComponent implements OnInit {

  constructor(private userService: UserService) {

  }

  ngOnInit(): void {
    this.userService.isRedirected$.next(true);
  }

}
